import BaseComponent from '../../components/base-component/base-component'
import type { Nullable } from '../../types/common'
import { checkMobileVersion } from '../../utils/check-media'
import { debounce } from '../../utils/debounce'
import type Carousel from '../carousel/carousel'
import type Tabs from '../tabs/tabs'

class ProductDetails extends BaseComponent {
  tabsComponentSelector: string
  carouselSelector: string

  tabsComponent: Nullable<Tabs>
  carousel: Nullable<Carousel>

  isMobile: boolean

  resizeObserver: ResizeObserver

  constructor() {
    super()

    this.tabsComponentSelector = 'tabs-component'
    this.carouselSelector = 'carousel-component'

    this.tabsComponent = this.querySelector(this.tabsComponentSelector)
    this.carousel = this.querySelector(this.carouselSelector)

    this.isMobile = checkMobileVersion()

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this.carousel)
  }

  connectedCallback(): void {
    customElements
      .whenDefined(this.tabsComponentSelector)
      .then(() => {
        this.tabsComponent?.subscribe('selectTab', this.handleTabSelect)
      })
      .catch(error => {
        console.log(error)
      })
  }

  disconnectedCallback(): void {
    this.tabsComponent?.unsubscribe('selectTab', this.handleTabSelect)
    this.resizeObserver.disconnect()
  }

  handleTabSelect = (): void => {
    this.scrollToActiveTab()
  }

  handleResize = debounce((): void => {
    const isMobile = checkMobileVersion()

    if (isMobile !== this.isMobile) {
      this.isMobile = isMobile
    }

    if (isMobile) {
      this.scrollToActiveTab()
    }
  }, 300)

  scrollToActiveTab = (): void => {
    const tabs = this.tabsComponent.tabNames.filter(tab => tab.clientWidth > 0)
    const activeTab = tabs.findIndex(
      tab => tab.dataset.id === this.tabsComponent.dataset.selectedTabId,
    )

    this.carousel?.scrollToIndex(activeTab)
  }
}

export default ProductDetails
